import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/features/string/repeat';
import { msalInstance } from './msalConfig';
 
const DO_NOT_LOGIN = true;

const accounts = msalInstance.getAllAccounts();

if (accounts.length === 0) {
  console.warn("No user is signed in. Skipping app load.");
  require('./indexApp.js');
} else {
  require('./indexApp.js');
}

